export const formatCurrency = (value) => {
  // Si el valor es un string con formato de moneda, extraer solo el número
  if (typeof value === "string" && value.includes("$")) {
    value = value.replace(/[^\d,-]/g, "");
  }

  // Si el valor es un string, convertirlo a número
  if (typeof value === "string" && !isNaN(value)) {
    value = Number(value);
  }

  // Si es un número válido, formatearlo
  if (typeof value === "number" && !isNaN(value)) {
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const formatted = formatter.format(value).replace(/\s/g, "");
    return {
      formatted,
      value,
    };
  }

  // Si no es un número válido, retornar cero formateado
  return {
    formatted: "$ 0",
    value: 0,
  };
};

export const parseCurrencyValue = (value) => {
  if (!value) return 0;

  // Remover todos los caracteres no numéricos excepto el punto decimal
  const numericValue = value.toString().replace(/[^\d.]/g, "");
  return Number(numericValue) || 0;
};

// Función para validar que el valor sea un número positivo
export const validateCurrencyValue = (value) => {
  const numericValue = parseCurrencyValue(value);
  return numericValue >= 0;
};
